import {
  CHAT_TYPE,
  GROUP_TYPE,
  IGroupChatData,
  IGroupInfo,
} from "@home-health-notify/domain";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { IChatAccess, OrganizationContext, useTranslation } from "hhn-commons";
import { useContext, useEffect, useState } from "react";

import theme from "../../theme";
import {
  PendingReferralsText,
  PendingReferralWrapper,
} from "../MessagePanel.style";

export const PendingAckStrip = ({
  chatAccess,
}: {
  chatAccess: IChatAccess;
}) => {
  const { t } = useTranslation();
  const { selectedOrgUser } = useContext(OrganizationContext);

  const isGroupChat = chatAccess.getChatType() === CHAT_TYPE.GROUP;
  const chatId = chatAccess.chatInfo.id;
  const groupType = isGroupChat
    ? (chatAccess.chatInfo as IGroupInfo).groupType
    : undefined;

  const [hasPendingAck, setHasPendingAck] = useState<boolean>(false);

  useEffect(() => {
    if (!selectedOrgUser || !isGroupChat || !groupType) {
      setHasPendingAck(false);
      return;
    }

    const manager = selectedOrgUser.chatManager.getChatManagerForGroupType(
      groupType as GROUP_TYPE,
    );
    if (!manager) {
      setHasPendingAck(false);
      return;
    }

    const readFlag = () => {
      const chats = (manager.getChats?.()?.chats ?? []) as IGroupChatData[];
      const found = chats.find(c => c.id === chatId);
      setHasPendingAck(!!found?.hasAcknowledgeMessage);
    };

    readFlag();
    const unsubscribe = manager.registerChangeListener(() => {
      readFlag();
    });
    return unsubscribe;
  }, [selectedOrgUser, isGroupChat, groupType, chatId]);

  if (!isGroupChat || !hasPendingAck) {
    return null;
  }

  return (
    <PendingReferralWrapper data-testid="pending-ack-strip">
      <ThumbUpIcon
        sx={{
          height: 18,
          width: 18,
          color: theme.palette.primary.main,
        }}
      />
      <PendingReferralsText variant="body1">
        {t("youHavePendingAcknowledgments", { ns: "message" })}
      </PendingReferralsText>
    </PendingReferralWrapper>
  );
};
